import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    backgroundColor: "#121212", // dark theme gallery
    color: "#ffffff",
    overflow: "hidden",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    borderBottom: "1px solid #2d2d2d",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(3),
    backgroundColor: "#000000",
    minHeight: 400,
    maxHeight: "80vh",
  },
  closeButton: {
    color: theme.palette.grey[500],
  },
  image: {
    maxWidth: "100%",
    maxHeight: "65vh",
    objectFit: "contain",
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
    border: "1px solid #1f1f1f",
  },
  noImageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#757575",
    gap: theme.spacing(2),
  },
}));

const PhotoGalleryDialog = ({ open, onClose, photoUrl, assetName }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      classes={{ paper: classes.dialogPaper }}
    >
      <Box className={classes.dialogTitle}>
        <Typography variant="h6" style={{ fontWeight: 600 }}>
          {assetName ? `${assetName} - Verification Photo` : "Photo Verification"}
        </Typography>
        <IconButton onClick={onClose} className={classes.closeButton} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent className={classes.dialogContent}>
        {photoUrl ? (
          <img
            src={photoUrl}
            alt={assetName || "Audited Asset Verification"}
            className={classes.image}
            onError={(e) => {
              e.target.onerror = null;
              // Add a generic fallback or show error
            }}
          />
        ) : (
          <Box className={classes.noImageContainer}>
            <PhotoCameraIcon style={{ fontSize: 64 }} />
            <Typography variant="body1">No verification photo attached.</Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PhotoGalleryDialog;
